import { useSelector } from 'react-redux'

import MeasurementsModerator from './Measurement.moderator.view'
import MeasurementsUser from './Measurement.user.view'

const Home = () => {
    const isModerator = useSelector((state) => state.profile.profile.isModerator)

    return isModerator ? <MeasurementsModerator /> : <MeasurementsUser />
}

export default Home
